"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messageBroker_1 = __importDefault(require("./messageBroker"));
class Command {
    constructor(id, action, manager) {
        this.id = id;
        this.action = action;
        this.manager = manager;
    }
    execute(params) {
        this.action(params);
    }
    sendAll(params) {
        this.manager.sendAllCommand(this, params);
    }
    sendTo(target, params) {
        messageBroker_1.default.sendCommand(this.id, target, params);
    }
    sendToRole(role, params) {
        if (typeof this.manager === 'undefined') {
            throw new Error('Command Manager not found');
        }
        const message = {
            type: 'command',
            command: this.id,
            args: params,
        };
        messageBroker_1.default.sendRoleMessage(message, role);
    }
}
exports.default = Command;
